import loadable from '@loadable/component';

import { otherSelector } from 'selectors/otherSelectors';
import { useAppSelector } from 'storeHooks';

const LazyNriModal = loadable(
  () => import(/* webpackChunkName: "AsyncNriFlowModal" */ './nriModal')
);

const NriModalWrapper = () => {
  const isNriNoticeModalOpen = useAppSelector(
    state => otherSelector(state).isNriNoticeModalOpen
  );

  if (!isNriNoticeModalOpen) return null;
  return <LazyNriModal />;
};

export { LazyNriModal };
export default NriModalWrapper;
